import http from "../../http";

export default {
  list: (params) => {
    return http.post('websitecenter/content/page', params)
  },
  save: (params) => {
    return http.post('websitecenter/content/save', params)
  },
  del: (params) => {
    return http.get('websitecenter/content/delete', params)
  },
  detail:  (params) => {
    return http.get('websitecenter/content/netapi/list', params)
  }
}
